import React from 'react'
import { lower } from 'change-case'
import { connect } from 'react-redux'
import { getFormValues, Field } from 'redux-form'

import { StdCard } from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'

import { FieldRow } from '../styled'

const ContactPerson = (props) => {
  const { 
    valueForm,
    members, 
    memberLoading, 
    purchaseOfficer,
    // props
    isEdit=false,
    isCreate=false,
    isDetail=false
  } = props

  const memberOptions = members.map(m => ({ value: lower(m.username), text: `${m.firstnameEn} ${m.lastnameEn}` }))

  return (
    <StdCard title='Contact Person' style={{ marginTop: '10px' }}>
      <FieldRow>
        <Field 
          name='prRequester' 
          label='PR Requester'
          type={type.select}
          options={memberOptions}
          loading={memberLoading}
          component={FieldInput}
          editable={!isDetail}
          require
        />
        <Field 
          name='prRequesterMobile' 
          label='Mobile'
          type={type.text}
          component={FieldInput}
          editable={!isDetail}
          require
        />
      </FieldRow>
      <FieldRow>
        <Field 
          name='purchasing' 
          label='Purchasing'
          type={type.select}
          options={!isDetail?purchaseOfficer.data.map((item,i)=>({key:`pu${i}`,value:item.username,text:item.fullNameEn})):memberOptions}
          loading={!isDetail?purchaseOfficer.loading:memberLoading}
          component={FieldInput}
          editable={!isDetail}
          require
        />
        <Field 
          name='purchasingMobile' 
          label='Mobile'
          type={type.text}
          component={FieldInput}
          editable={!isDetail}
          require
        />
      </FieldRow>
      <FieldRow>
        <Field 
          name='supplierName' 
          label='Vendor Name'
          type={type.text}
          component={FieldInput}
          editable={!isDetail}
          require
        />
        <Field 
          name='supplierMobile' 
          label='Mobile'
          type={type.text}
          component={FieldInput}
          editable={!isDetail}
          require
        />
      </FieldRow>
      <FieldRow>
        <Field 
          name='supplierEmail' 
          label={`Vendor's Email`}
          type={type.text}
          component={FieldInput}
          editable={!isDetail}
          className={'halfRow'}
          require
          footer={
            <div style={{color:'red',fontWeight:'bold'}}>
              <div>Please fill in correct email address.</div><bt/>
              <div>Example : vendor_email001@hotmail.com; vendor_email002@gmail.com; ...</div>
            </div>
          }
        />
      </FieldRow>
      {valueForm&&valueForm.legalOfficerName&&<FieldRow>
        <Field 
          name='legalOfficerName' 
          label='Contact'
          type={type.text}
          component={FieldInput}
          editable={false}
        />
        <Field 
          name='legalOfficerMobile' 
          label='Mobile'
          type={type.text}
          component={FieldInput}
          editable={false}
        />
      </FieldRow>}
    </StdCard>
  )
}

const mapStateToProps = (state) => ({
  members: state.member.members,
  memberLoading: state.member.memberLoading,
  purchaseOfficer: state.options.purchaseOfficer,
  valueForm: getFormValues('formContract')(state),
})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(ContactPerson)